import { useState } from 'react'
import { signup as signupService } from '../services/authService';
import { trackSignup } from '../utils/metaPixel';

export const useSignup = () => {

  // Removed unused error state
  // const [error, setError] = useState(null)
  const [isLoading, setIsLoading] = useState(null)

  const signup = async (formData) => {
     setIsLoading(true);
     // Removed setting error state
     // setError(null);

     try {
      // Convert email to lowercase before sending to the service
      const lowerCaseFormData = {
        ...formData,
        email: formData.email.toLowerCase() // Corrected access to email property
      };
      const response = await signupService(lowerCaseFormData);
      // dispatch({type: 'REGISTER', payload: null});
      setIsLoading(false);
      if (response && response.success !== false) trackSignup();
      // The service should ideally return { success, message, ... }
      return response; // Return the whole response which includes success and message
  } catch (error) { // Kept error in catch block for logging/handling before returning
      setIsLoading(false);
      if (error.response) {
          // setError(error.response.data.message || 'An error occurred. Please try again.'); // Removed setting error state
          return { success: false, message: error.response.data.message || 'An error occurred. Please try again.' };
        } else if (error.request) {
          // setError('No response from the server. Please check your network connection.'); // Removed setting error state
          return { success: false, message: 'No response from the server. Please check your network connection.' };
        } else {
          // setError('An unexpected error occurred. Please try again.'); // Removed setting error state
          return { success: false, message: 'An unexpected error occurred. Please try again.' };
        }
  }
  };

  // Removed error from the return
  return { signup, isLoading }
}